export class ItActivity {
  activity: string;
  activityDescription: string;
  accountingModel: string;
  accountingTreatment: string;
  businessUnit?: string;

  constructor(activity?: string, activityDescription?: string) {
    this.activity = activity;
    this.activityDescription = activityDescription;
    this.accountingModel = '';
    this.accountingTreatment = '';
  }
}
